import { BreakpointObserver } from '@angular/cdk/layout'
import { Component, OnInit, ViewChild } from '@angular/core'
import { MatSidenav } from '@angular/material/sidenav'

@Component({
    selector: 'nuctrac-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: false
})
export class MainComponent implements OnInit {
  @ViewChild(MatSidenav)
  sidenav!: MatSidenav

  showNavBar = false
  hideHeader!: boolean

  constructor(private observer: BreakpointObserver) {}

  ngOnInit(): void {
  }

  onClickeMenuIcon() {
    this.showNavBar = !this.showNavBar
  }

  setHeaderStatus(value: any) {
    this.hideHeader = value
  }

  ngAfterViewInit() {
    this.observer.observe(['(max-width: 800px)']).subscribe((res) => {
      if (res.matches) {
        this.showNavBar = false
      } else {
        this.showNavBar = true
      }
    })
  }
}
